import { makeStyles, tokens, Dropdown, Option, Spinner, Body1 } from '@fluentui/react-components';
import { useMyProjects } from '../api/hooks';

// Shared project selector used by every programme + customer report. Reads from
// /api/reports/projects (the role-filtered list of projects the caller can see) so an
// Administrator at a customer only sees their own projects in the dropdown.
const useStyles = makeStyles({
  wrapper: { display: 'flex', alignItems: 'center', gap: tokens.spacingHorizontalM },
  dropdown: { minWidth: '20rem' },
  hint: { color: tokens.colorNeutralForeground2 },
});

interface ProjectPickerProps {
  selectedProjectId: string | undefined;
  onSelect: (projectId: string | undefined) => void;
}

export function ProjectPicker({ selectedProjectId, onSelect }: ProjectPickerProps) {
  const styles = useStyles();
  const { data: projects, isLoading } = useMyProjects();

  if (isLoading) return <Spinner size="tiny" label="Loading projects…" />;
  if (!projects || projects.length === 0) {
    return <Body1 className={styles.hint}>No projects are visible to you yet.</Body1>;
  }

  return (
    <div className={styles.wrapper}>
      <Body1 id="project-picker-label">Project:</Body1>
      <Dropdown
        className={styles.dropdown}
        aria-labelledby="project-picker-label"
        placeholder="Choose a project"
        selectedOptions={selectedProjectId ? [selectedProjectId] : []}
        value={projects.find((p) => p.id === selectedProjectId)?.name ?? ''}
        onOptionSelect={(_e, d) => onSelect(d.optionValue ?? undefined)}
      >
        {projects.map((p) => (
          <Option key={p.id} value={p.id} text={p.name}>{p.name}</Option>
        ))}
      </Dropdown>
    </div>
  );
}
